import React from 'react';
import styled from '@emotion/styled';
import {
  Container,
  Grid,
  IconButton,
  Paper,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import NewRow from './NewRow';
import { useNavigate } from 'react-router-dom';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import BlurOnIcon from '@mui/icons-material/BlurOn';
import BlurOffIcon from '@mui/icons-material/BlurOff';
import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import { useSelector } from 'react-redux';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import EditNoteIcon from '@mui/icons-material/EditNote';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import PermMediaIcon from '@mui/icons-material/PermMedia';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(0),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const ListContainer = ({
  rightsideicon,
  notitle,
  goBack,
  goSave,
  linkToNew,
  children,
  title,
  sx,
  addable = true,
  twoValue = false,
  newRow,
  setNewRow,
  options,
  firstValueDefault,
  visibility = false,
  setVisibility,
  showStages = false,
  setShowStages,
  sortByType,
  setShowSortedByType,
  bgcolor,
  projectTools,
  showCreatedAt,
  setShowCreatedAt,
  buttons,
  userRoles = [],
}) => {
  const navigate = useNavigate();
  const { userInfo } = useSelector((state) => state.auth);
  const handleAddNew = () => {
    if (linkToNew) {
      navigate(linkToNew);
    } else {
      setNewRow(true);
    }
  };

  const handleChangeVisibility = () => {
    setVisibility(!visibility);
  };

  let selectable = false;
  if (Array.isArray(options)) {
    selectable = true;
  }

  // console.log(rightsideicon);
  return (
    <Container maxWidth={false} sx={{ p: 0, m: 0, maxWidth: '720px' }}>
      {!notitle && (
        <Grid
          item
          xs={12}
          spacing={1}
          container
          sx={{ pb: 0, mb: 0 }}
          alignItems='center'
        >
          <Grid item xs={10}>
            <Typography variant='h6'>{title}</Typography>
          </Grid>

          <Grid
            item
            xs={2}
            justifyContent='flex-end'
            alignItems='center'
            container
          >
            {rightsideicon ? (
              <Item>
                <IconButton aria-label='settings' onClick={goBack}>
                  {rightsideicon}
                </IconButton>
              </Item>
            ) : goBack ? (
              <Item>
                <IconButton aria-label='settings' onClick={goBack}>
                  <CloseIcon />
                </IconButton>
              </Item>
            ) : null}
          </Grid>
        </Grid>
      )}
      <Grid item xs={12} spacing={1} container sx={{ pb: 0, mb: 0 }}>
        <Grid item xs={projectTools?.goBack ? 10 : 12}>
          <Stack direction='row' spacing={2} sx={{ mb: 1 }}>
            {projectTools && (
              <>
                {userRoles.includes('UPLOAD_PHOTO') && (
                  <Item>
                    <IconButton
                      aria-label='add to favorites'
                      href='#file-upload'
                      component='label'
                      onClick={() => projectTools.setOpenUploadDialog(true)}
                    >
                      <AddAPhotoIcon />
                    </IconButton>
                  </Item>
                )}
                {(userInfo.isAdmin ||
                  userRoles.includes('CREATE_NEW_PROJECT') ||
                  userRoles.includes('EDIT_PROJECT') ||
                  userRoles.includes('UPLOAD_PHOTO') ||
                  userRoles.includes('DELETE_PROJECT')) && (
                  <>
                    <Item>
                      <IconButton
                        aria-label='share'
                        onClick={() =>
                          projectTools.setShowTools(!projectTools.showTools)
                        }
                      >
                        {projectTools.showTools ? (
                          <ToggleOnIcon />
                        ) : (
                          <ToggleOffIcon />
                        )}
                      </IconButton>
                    </Item>
                    {projectTools.showTools && (
                      <>
                        {(userInfo.isAdmin ||
                          userRoles.includes('EDIT_PROJECT')) && (
                          <Item>
                            <IconButton
                              aria-label='share'
                              onClick={projectTools.goEdit}
                            >
                              <EditNoteIcon />
                            </IconButton>
                          </Item>
                        )}
                        {(userInfo.isAdmin ||
                          userRoles.includes('CREATE_NEW_PROJECT')) && (
                          <Item>
                            <IconButton
                              aria-label='share'
                              onClick={() =>
                                projectTools.goInvisible(
                                  !projectTools.project?.visible
                                )
                              }
                            >
                              {projectTools.project?.visible ? (
                                <VisibilityIcon />
                              ) : (
                                <VisibilityOffIcon sx={{ color: '#8d6e63' }} />
                              )}
                            </IconButton>
                          </Item>
                        )}
                        {(userInfo.isAdmin ||
                          userRoles.includes('UPLOAD_PHOTO')) && (
                          <Item>
                            <IconButton
                              aria-label='share'
                              onClick={projectTools.goToImagesList}
                            >
                              <PermMediaIcon />
                            </IconButton>
                          </Item>
                        )}

                        {(userInfo.isAdmin ||
                          userRoles.includes('DELETE_PROJECT')) && (
                          <Item>
                            <IconButton
                              aria-label='share'
                              onClick={projectTools.goDelete}
                            >
                              <DeleteForeverIcon />
                            </IconButton>
                          </Item>
                        )}
                      </>
                    )}
                  </>
                )}
              </>
            )}
            {addable &&
              typeof goSave === 'function' &&
              (userInfo.isAdmin ||
                userRoles.includes('CREATE_NEW_PROJECT')) && (
                <Item>
                  <Tooltip title='Создать новый'>
                    <IconButton aria-label='tools' onClick={handleAddNew}>
                      <PlaylistAddIcon />
                    </IconButton>
                  </Tooltip>
                </Item>
              )}
            {typeof setVisibility === 'function' && (
              <Item>
                <Tooltip title='Показывать скрытые'>
                  <IconButton
                    aria-label='tools'
                    onClick={handleChangeVisibility}
                  >
                    {visibility ? <VisibilityOffIcon /> : <VisibilityIcon />}
                  </IconButton>
                </Tooltip>
              </Item>
            )}

            {/* {typeof setShowStages === 'function' && (
              <Item>
                <Tooltip title='Показывать этапы'>
                  <IconButton
                    aria-label='tools'
                    onClick={() => setShowStages(!showStages)}
                  >
                    {showStages ? <BlurOffIcon /> : <BlurOnIcon />}
                  </IconButton>
                </Tooltip>
              </Item>
            )} */}

            {/* {typeof setShowSortedByType === 'function' && (
              <Item>
                <Tooltip title='Группировать по типам'>
                  <IconButton
                    aria-label='tools'
                    onClick={() => setShowSortedByType(!sortByType)}
                  >
                    {sortByType ? (
                      <FormatAlignJustifyIcon />
                    ) : (
                      <FormatAlignCenterIcon />
                    )}
                  </IconButton>
                </Tooltip>
              </Item>
            )} */}
            {typeof setShowCreatedAt === 'function' && (
              <Item>
                <Tooltip title='Показывать дату'>
                  <IconButton
                    aria-label='tools'
                    onClick={() => setShowCreatedAt()}
                  >
                    {showCreatedAt ? (
                      <CalendarMonthIcon />
                    ) : (
                      <CalendarTodayIcon />
                    )}
                  </IconButton>
                </Tooltip>
              </Item>
            )}
            {Array.isArray(buttons) && buttons.length > 0 && (
              <>
                {buttons.map((el) => (
                  <Tooltip
                    key={el.label}
                    title={el?.label}
                    placement='top-start'
                  >
                    <Item>{el.component}</Item>
                  </Tooltip>
                ))}
              </>
            )}
          </Stack>
        </Grid>
        {projectTools?.goBack && (
          <Grid item xs={2}>
            <Item>
              <IconButton aria-label='settings' onClick={projectTools.goBack}>
                <CloseIcon />
              </IconButton>
            </Item>
          </Grid>
        )}
      </Grid>
      {newRow && (
        <NewRow
          twoValue={twoValue}
          goSave={goSave}
          setNewRow={setNewRow}
          selectable={selectable}
          options={options}
          firstValueDefault={firstValueDefault}
        />
      )}
      {children}
    </Container>
  );
};

export default ListContainer;
